import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from "react";
import { useCombineRefs } from "../hooks/useCombineRefs";
import { useTagRowWraps } from "../hooks/useTagRowWraps";
import * as Styled from "./Toolbar.styled";
export const Toolbar = forwardRef(({ children, inert, size = "small", align, ...otherProps }, ref) => {
    const toolbarRef = useRef(null);
    useTagRowWraps(toolbarRef);
    return (_jsx(Styled.Toolbar, { "data-testid": "Toolbar", 
        // TODO: use boolean value when React supports it https://github.com/facebook/react/pull/24730
        inert: inert ? "true" : undefined, ref: useCombineRefs(toolbarRef, ref), role: "toolbar", "$size": size, "$align": align, keyboardDirection: "horizontal", keyboardEventMustMatchItemSelector: true, ...otherProps, children: children }));
});
Toolbar.displayName = "Toolbar";
